import React, { FC, ReactNode, useCallback } from 'react';
import { ActionButtonsType, IActionButtons, IDialogResult, useDialog } from './DialogContext';

interface IProps {
    message: string | ReactNode;
}

const DialogConfirmation: FC<IProps> = props => {
    return (
        <div className="form-row pt-2">
            <div className="col-12" style={{ whiteSpace: 'pre-wrap' }}>
                {props.message}
            </div>
        </div>
    );
};

export const useConfirmation = () => {
    const { showDialogAsync } = useDialog();

    const confirmAsync = useCallback(
        (title: string, message: string | ReactNode, actionButtons?: ActionButtonsType | IActionButtons): Promise<IDialogResult<void>> =>
            showDialogAsync({
                title,
                component: <DialogConfirmation message={message} />,
                actionButtons
            }),
        []
    );

    return {
        confirmAsync
    };
};

export default DialogConfirmation;
